import React from "react";
import { useLocation } from "react-router-dom";
import Login from "../components/Login";
import store from "../assets/store.jpg";
const Account = () => {
  return (
    <div className="body">
      <div className="account_container">
        <div className="login_thumbnail">
          <img src={store} alt="" />
          <div className="overlay">
            <h3>#1 Shopping Platform in Bantigue</h3>
          </div>
        </div>
        <Login />
      </div>
    </div>
  );
};

export default Account;
